export default __webpack_public_path__ + "static/media/logo-dark.7537df1d.png";